module.exports = __webpack_public_path__ + "media/images/openrounds-spinner-4c3fe2c6eb5282f6f2246ea3f1872a14.png";